import { render, staticRenderFns } from "./RatingModal.vue?vue&type=template&id=315b9b28&scoped=true"
import script from "./RatingModal.vue?vue&type=script&lang=js"
export * from "./RatingModal.vue?vue&type=script&lang=js"
import style0 from "./RatingModal.vue?vue&type=style&index=0&id=315b9b28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315b9b28",
  null
  
)

export default component.exports